@if (state(); as ie) {
	<small
		class="user-invite-expiration-row"
		[class.user-invite-expiration-row_expired]="ie.status === 'expired'"
	>
		@switch (ie.status) {
			@case ('loading') {
				{{ 'user.invite-expiry-loading' | transloco }}
			}
			@case ('missing') {
				{{ 'user.invite-expiry-missing' | transloco }}
			}
			@case ('active') {
				{{
					'user.invite-expires'
						| transloco
							: {
									date: (ie.expiresAt | date: 'mediumDate'),
							  }
				}}
			}
			@case ('expired') {
				{{
					'user.invite-expired'
						| transloco
							: {
									date: (ie.expiresAt | date: 'mediumDate'),
							  }
				}}
			}
		}
	</small>
}
